import React from 'react';

import Page from 'components/Page';
import ThumbnailGallery from 'components/ThumbnailGallery';

const GalleryTemplate = ({ page: { acf: { images } } }) => (
    <Page>
        <ThumbnailGallery images={images.map((imageItem) => imageItem.image)} />
    </Page>
);


export default GalleryTemplate;
